// 要素
const closureElm = document.getElementById('js-closure');

// オブザーバインスタンスを作成
const observer = new MutationObserver(records => {
  // 変化が発生したときの処理を記述
  page_anchor();
});
// 監視の開始
observer.observe(closureElm, {
  // オプションを指定
  attributes: true, // 属性の変化を監視
  childList: true, // 子ノードの変化を監視
});


// 休診代診
function getClosure(){
  const requestUrl = 'https://kotobuki-ent.com/system/higashi-kawaguchi/closure.php'; // 本番サーバー
  //const requestUrl = 'http://localhost:8288/system/higashi-kawaguchi/closure.php'; // Local

  $.post( requestUrl, function( data ){
    closureElm.innerHTML = data;
  });
}



// Initialize
document.addEventListener('DOMContentLoaded', function() {

// 休診代診
getClosure();

});
